import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import injectSheet from 'react-jss';
import {
  Button,
  Col,
  Row,
  Typography,
} from 'antd';
import { classesPropType, historyPropType } from '../prop-types';

const { Title } = Typography;

const GRID_OPTIONS = { md: { span: 22, offset: 1 }, lg: { span: 18, offset: 3 } };

const styles = {
  title: {
    textAlign: 'center',
  },
  goBackContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
};

function LegalContent({
  children,
  classes,
  history: { goBack },
  title,
}) {
  const { t } = useTranslation();
  const handleGoBackPress = useCallback(() => goBack(), [goBack]);
  return (
    <Row>
      <Col {...GRID_OPTIONS}>
        <div className={classes.goBackContainer}>
          <Button type="primary" icon="arrow-left" onClick={handleGoBackPress}>
            {t('actions.goBack')}
          </Button>
        </div>
        <Title className={classes.title}>{title}</Title>
        {children}
      </Col>
    </Row>
  );
}

LegalContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  classes: classesPropType.isRequired,
  history: historyPropType.isRequired,
  title: PropTypes.string.isRequired,
};

export default withRouter(injectSheet(styles)(LegalContent));
